import { PageNotFound } from "./PageNotFound";
import { Subscriptions } from "./Subscriptions";
import { ResourceGroupPage } from "./";
import { TenantPage } from "./TenantPage";
import { SubscriptionPage } from "./Subscription";
import { BasicPageLayout } from "./BasicPageLayout";
import { UserPage } from "./UserPage";

export const routes = [
  {
    path: "/",
    element: (
      <BasicPageLayout>
        <Subscriptions />
      </BasicPageLayout>
    ),
  },
  {
    path: "/auth-response",
    element: (
      <BasicPageLayout>
        <Subscriptions />
      </BasicPageLayout>
    ),
  },
  {
    path: "/subscriptions",
    element: (
      <BasicPageLayout>
        <Subscriptions />
      </BasicPageLayout>
    ),
  },
  {
    path: "/subscriptions/:subscriptionId",
    element: (
      <BasicPageLayout>
        <SubscriptionPage />
      </BasicPageLayout>
    ),
  },
  {
    path: "/subscriptions/:subscriptionId/resourceGroups/:resourceGroupId",
    element: (
      <BasicPageLayout>
        <ResourceGroupPage />
      </BasicPageLayout>
    ),
  },
  {
    path: "/subscriptions/:subscriptionId/tenants/:tenantId",
    element: (
      <BasicPageLayout>
        <TenantPage />
      </BasicPageLayout>
    ),
  },
  {
    path: "/subscriptions/:subscriptionId/users/:userId",
    element: (
      <BasicPageLayout>
        <UserPage />
      </BasicPageLayout>
    ),
  },
  {
    path: "*",
    element: (
      <BasicPageLayout>
        <PageNotFound />
      </BasicPageLayout>
    ),
  },
];
